import { render } from "./QwilrSubstitutionMappingPage.vue?vue&type=template&id=aaeab046&ts=true"
import script from "./QwilrSubstitutionMappingPage.vue?vue&type=script&lang=ts"
export * from "./QwilrSubstitutionMappingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__